import styled from 'styled-components';

const MainKontaktDiv = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px;
`;

const StyledH1 = styled.h1`
  border-bottom: 2px dashed grey;
`;

const StyledA = styled.a`
  text-decoration: none;
  color: black;
  &:visited {
    color: black;
  }
  &:hover{
      color: #85be80;
  }
`;

export const Kontakt = (params) => {
  return (
    <MainKontaktDiv>
      <StyledH1>Kontakt: </StyledH1>
      <p>Telefon Kom: 693 649 114</p>
      <p>
        E-Mail:{' '}
        <StyledA href="mailto: klubdzieciecybiedroneczki@interia.pl">
          klubdzieciecybiedroneczki@interia.pl
        </StyledA>
      </p>
      <p>
        Facebook:{' '}
        <StyledA
          href="https://www.facebook.com/Klub-Dzieci%C4%99cy-Biedroneczki-106424707422204/?ref=page_internal"
          target="blank"
        >
          Klub-Dziecięcy-Biedroneczki{' '}
        </StyledA>
      </p>
      <p>
        Adres:{' '}
        <StyledA
          href="https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.google.com%2Fmaps%2Fdir%2F%3Fapi%3D1%26destination%3D54.59817%252C18.3530799%26fbclid%3DIwAR16o1JQFJ5nlph9ItiAESmM4bO1wAwHlEaZyznow8oLA-iPuIyEQobFs1g&h=AT2bbHxXpXUhmk8sMqEewohu2ShxMO1AS5uBWni2-pIyRPNyBP-36H_obsNXSa180naWvmvRG186s8MOcxudn7pjqtAjcwZ2bEL78oHejckM_XNlE9XWGS7R-mLoCQ"
          target="blank"
        >
          ul. Gdańska 45 84-240 Reda
        </StyledA>
      </p>
    </MainKontaktDiv>
  );
};
